/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Fit_1Inputs */

const en_pc_alt_fit_1 = /** @type {(inputs: Pc_Alt_Fit_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You read, search and annotate PDFs and want a free, native app with no account.`)
};

const zh_pc_alt_fit_1 = /** @type {(inputs: Pc_Alt_Fit_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你需要阅读、搜索和批注 PDF，想要一款免费、原生、无需账号的应用。`)
};

/**
* | output |
* | --- |
* | "You read, search and annotate PDFs and want a free, native app with no account." |
*
* @param {Pc_Alt_Fit_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_fit_1 = /** @type {((inputs?: Pc_Alt_Fit_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Fit_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_fit_1(inputs)
	return zh_pc_alt_fit_1(inputs)
});
export { pc_alt_fit_1 as "pc.alt.fit.1" }